<template>
  <div :class="classObject">
    <span>
      <i :class="icon"
         v-if="icon"
      ></i>
      <slot></slot>
    </span>

    <button v-if="closeButton" class="close"></button>
  </div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  disabled: Boolean,
  icon: String,
  large: Boolean,
  rounded: Boolean,
  small: Boolean,
  type: String,
  closeButton: {
    type: Boolean,
    default: false
  }
});

const classObject = computed(() => ({
  [props.type] : true,
  'disabled' : props.disabled,
  'rounded' : props.rounded,
  'large' : props.large,
  'small' : props.small
}));
</script>